module.exports = __webpack_public_path__ + "img/premium_slideimage03.b4fd9820.jpg";